import React from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import { MODALIDADES } from "@/data/formConfig";

const Field = ({ label, children }) => (
  <div>
    <label className="block text-white/70 text-xs mb-1.5">{label}</label>
    {children}
  </div>
);

const Sel = ({ options, placeholder, testId }) => (
  <select data-testid={testId} defaultValue="" className="af-input" style={{ appearance: "none" }}>
    <option value="" disabled>{placeholder}</option>
    {options.map((o) => <option key={o} value={o}>{o}</option>)}
  </select>
);

export default function Buscador() {
  const navigate = useNavigate();
  const onSubmit = (e) => {
    e.preventDefault();
    const el = document.getElementById("ofertas");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <section id="buscador" className="py-14 md:py-16" style={{ background: "var(--af-black)" }}>
      <div className="af-container">
        <div className="af-card p-6 md:p-8">
          <div className="mb-6">
            <div className="text-af-orange-core font-display uppercase tracking-widest text-sm mb-2">Buscador</div>
            <h2 className="h-impact text-white text-2xl md:text-3xl">Encuentra tu vehículo ideal</h2>
          </div>
          <form onSubmit={onSubmit} className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            <Field label="Marca"><Sel testId="bus-marca" placeholder="Todas" options={["Nissan","Volkswagen","Mazda","Toyota","Chevrolet","Ford","Kia","Honda"]} /></Field>
            <Field label="Modelo"><input data-testid="bus-modelo" className="af-input" placeholder="Cualquiera" /></Field>
            <Field label="Tipo de vehículo"><Sel testId="bus-tipo" placeholder="Todos" options={["Automóvil","SUV","Pickup","Van","Camión","Tractocamión","Maquinaria pesada"]} /></Field>
            <Field label="Modalidad"><Sel testId="bus-modalidad" placeholder="Todas" options={MODALIDADES} /></Field>
            <Field label="Precio máximo"><Sel testId="bus-precio" placeholder="Sin límite" options={["$300,000","$500,000","$700,000","$900,000","Más de $900,000"]} /></Field>
            <Field label="Mensualidad máxima"><Sel testId="bus-mensualidad" placeholder="Sin límite" options={["$5,000","$8,000","$12,000","$15,000"]} /></Field>
            <Field label="Enganche"><Sel testId="bus-enganche" placeholder="Cualquiera" options={["Sin enganche","Menos del 10%","10% al 20%","Más del 20%"]} /></Field>
            <Field label="Nuevo / Seminuevo"><Sel testId="bus-condicion" placeholder="Todos" options={["Nuevo","Seminuevo"]} /></Field>
            <Field label="Uso"><Sel testId="bus-uso" placeholder="Cualquiera" options={["Personal","Trabajo","Familiar","Comercial"]} /></Field>
            <Field label="Ciudad / Estado"><Sel testId="bus-ciudad" placeholder="Todo México" options={["CDMX","Estado de México","Jalisco","Nuevo León","Puebla","Querétaro"]} /></Field>
            <Field label="Combustible"><Sel testId="bus-combustible" placeholder="Todos" options={["Gasolina","Diésel","Híbrido","Eléctrico"]} /></Field>
            <Field label="Transmisión"><Sel testId="bus-transmision" placeholder="Todas" options={["Automática","Manual","CVT"]} /></Field>
            <Field label="Año"><Sel testId="bus-anio" placeholder="Cualquiera" options={["2025","2024","2023","2022","2021"]} /></Field>
            <div className="flex items-end col-span-2 md:col-span-1">
              <button data-testid="bus-submit" type="submit" className="af-btn-primary w-full">
                <Search size={18} /> Buscar
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}
